import Wallets from "../../components/wallets";

const WalletsPage: React.FC = () => <Wallets />;

export default WalletsPage;
